import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { NForm, NCard, NSpace, NFormItem, NColorPicker, NTable, NThead, NTbody, NTh, NTr, NTd, NText, NButton } from 'naive-ui'
import AppLayoutMixin from "@/app-layout-mixin";
import EmbedCode from "@/components/embed";


createApp({
    components: { NForm, NCard, NSpace, NFormItem, NColorPicker, NTable, NThead, NTbody, NTh, NTr, NTd, NText, NButton, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            textColor: '#000000',
            backgroundColor: '#FFFFFF'
        }
    },
    computed: {

        ratio() {
            const textLuminance = this.luminance(this.colorToRgb(this.textColor));
            const backgroundLuminance = this.luminance(this.colorToRgb(this.backgroundColor));

            return textLuminance > backgroundLuminance
                ? ((backgroundLuminance + 0.05) / (textLuminance + 0.05))
                : ((textLuminance + 0.05) / (backgroundLuminance + 0.05));
        },

        previewStyle() {
            return {
                backgroundColor: this.backgroundColor,
                color: this.textColor
            };
        }

    },
    methods: {

        colorToRgb(color) {
            if (color.indexOf('rgb') === 0) {
                const result = color.match(/^rgb\((\d+), ?(\d+), ?(\d+)\)/);
                return result ? {
                    r: parseInt(result[1]),
                    g: parseInt(result[2]),
                    b: parseInt(result[3])
                } : null;
            }

            const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            color = color.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },

        luminance(rgbColor) {
            const a = [ rgbColor.r, rgbColor.g, rgbColor.b ].map(function (v) {
                v /= 255;
                return v <= 0.03928
                    ? v / 12.92
                    : Math.pow( (v + 0.055) / 1.055, 2.4 );
            });
            return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
        },

        swapColors() {
            [ this.textColor, this.backgroundColor ] = [ this.backgroundColor, this.textColor ];
        }

    }
}).mount('#app')
